import { colorSetCodes, turnCount } from 'features/turn/services/constants';
import turnSelectors, { turnManualSelectors } from 'features/turn/services/selectors';
import { ITurnManualItem, ITurnManualSettingColorItem } from 'features/turn/services/types/turn';
import { get } from 'lodash';
import { useMemo } from 'react';
import styled from 'styled-components';
import { getStaffNextTurn } from '../StaffTurns/helpers';
import TurnTableData from './TurnTableData';
type Props = {
  filterTurn?: (turns: ITurnManualItem[]) => void;
  tableKey?: string;
  turnCount?: number;
  simpleStaffTurn?: boolean;
  v2?: boolean;
};
const TurnTable = ({ filterTurn, tableKey, turnCount: _turnCount = turnCount, simpleStaffTurn = false, v2 = false }: Props) => {
  const mappingStaffs = turnManualSelectors.mappingStaffs();
  const _mappingStaffs = turnSelectors.mappingStaffsByService();
  
  const mappingStaffsByService = v2
    ? _mappingStaffs
    : mappingStaffs;

  const staffNextTurn = useMemo(() => getStaffNextTurn(mappingStaffsByService), [mappingStaffsByService]);
  const turnSettingColors = turnManualSelectors.settingColors();
  return (
    <Container turnSettingColors={turnSettingColors} v2={v2}>
      <table>
        <tbody>
          <tr>
            <td className='staff-top-row-sticky' style={{ padding: '0', background: '#fff' }}></td>
            <td colSpan={_turnCount + 1} style={{ padding: '4px 0', background: '#fff' }}></td>
          </tr>
          <TurnTableData
            staffs={mappingStaffs}
            nextStaffId={staffNextTurn?.staffId || ''}
            filterTurn={filterTurn}
            tableKey={tableKey}
            turnCount={_turnCount} 
            simpleStaffTurn={simpleStaffTurn}
            />
        </tbody>
      </table>
    </Container>
  );
};

export default TurnTable;

// const TurnNumbers = () => <>{Array.from(Array(turnCount).keys()).map(o => (<TurnHeadItem key={o} number={o + 1} />))}</>;

const Container = styled.div<{ turnSettingColors: ITurnManualSettingColorItem[], v2: boolean }>`
  @keyframes zoomNextStaff {
    0% {
      transform: scale(0.8);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: scale(1.2);
    }
  }

  table {
    border-collapse: collapse;
    width: 100%;
    thead {
      th {
        background: #F0F0F0;
        position: sticky;
        top: 0px;
        padding-top: 16px;
        z-index: 3;
        &.staff-top-row-sticky {
          z-index: 4;
          top: 0px;
          left: 0px;
        }
        &.top-header-row-sticky {
          z-index: 4;
          top: 0px;
          left: 240px;
        }
      }
    }

    tbody {
      .TurnBodyItem .box-item {
      ${({ turnSettingColors, v2 }) =>
        turnSettingColors.map(o => {
          const theme = get(colorSetCodes, o?.color || '');

          const currentTheme =
            v2 && o?.color === 'blue'
              ? {
                  ...theme,
                  bg: '#FF7D00',
                  stroke: '#C46A00',
                  shadow: '#C46A00',
                }
              : theme;

          if (o.turnStatus === 'NEXT') {
            return `
              &.${o.turnStatus} {
                background: ${currentTheme.bg};
                border: 1px solid ${currentTheme.stroke};
                box-shadow: 4px 4px 0px 0px ${currentTheme.shadow};

                .container-full {
                  background: ${currentTheme.bg};
                }
              }
            `;
          }

          return `
            &.${o.turnStatus} {
              background: ${currentTheme.bg};
              border: 1px solid ${currentTheme.stroke};
              box-shadow: 4px 4px 0px 0px ${currentTheme.shadow};
            }
          `;
        })}
      }
      td {
        background: #fff;
      }
      td.staff-top-row-sticky {
        position: sticky;
        left: 0px;
        background: #fff;
        z-index: 2;
        transform: translateX(-2px);

        &.active {
          background: #c6e9ef;
        }
      }
    }
  }
`;
